import { render, staticRenderFns } from "./DetailPageLayout.vue?vue&type=template&id=861638ac&scoped=true"
import script from "./DetailPageLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailPageLayout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DetailPageLayout.vue?vue&type=style&index=0&id=861638ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861638ac",
  null
  
)

export default component.exports